module.exports = __webpack_public_path__ + "img/ES_FundedbytheEU_RGB_POS.png";